import React from "react";
import { withRouter, RouteComponentProps } from "react-router-dom";
import { TitleTemplatesGroupStyled, SubTitle, Title } from "./styled";
import { observer } from "mobx-react";

interface Props extends RouteComponentProps<any> {
  title: string | React.ReactNode;
  subTitle: string;
  style?: any;
}

@observer
class TitleTemplatesGroup extends React.PureComponent<Props, any> {
  render() {
    const { title, subTitle, style } = this.props;
    return (
      <TitleTemplatesGroupStyled style={style}>
        <Title children={title} />
        <SubTitle children={subTitle} />
      </TitleTemplatesGroupStyled>
    );
  }
}
export default withRouter(TitleTemplatesGroup);
